import 'babel-polyfill';
import {createApp} from 'vue';
import Login from './Login.vue';
import axios from 'axios';
import FloatingVue from 'floating-vue';
import { vMaska } from 'maska/vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faEyeSlash, faEye, faExclamationTriangle, faPlusCircle, faBars, faUser, faInfoCircle, faPen, faCheckCircle, faTimesCircle, faArrowLeft, faAngleRight, faAngleLeft, faAngleDown, faCircle, faTimes, faLock, faHandHoldingUsd, faQuestionCircle, faExternalLinkAlt, faSlidersH, faExclamation, faEllipsisH, faEnvelope, faEnvelopeOpen, faTrash, faFolderOpen, faSave, faFilePdf, faFileWord, faFileImage, faFilePowerpoint, faFileArchive, faFileVideo, faFileAudio, faFileExcel, faFileCsv, faFileCode, faFile } from '@fortawesome/free-solid-svg-icons';
import { faCalendarAlt, faCalendarTimes, faCopy, faFilePdf as regularFaFilePdf } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import 'bootstrap/dist/css/bootstrap.min.css';
import "floating-vue/dist/style.css";
import '@vuepic/vue-datepicker/dist/main.css';
import cssVars from 'css-vars-ponyfill';
import "./assets/style.css";
import mitt from 'mitt';
import InputTrimPlugin from './plugins/input-trim-plugin';
import DataTable from 'datatables.net-vue3'
import DataTablesCore from 'datatables.net-bs4';
import FloatingVueEscapeKeyPlugin from './plugins/floating-vue-escape-key-plugin';

DataTable.use(DataTablesCore);

const app = createApp(Login);

const emitter = mitt();
app.config.globalProperties.$emitter = emitter;

axios.defaults.headers.common["Content-Type"] = "application/json";
axios.defaults.headers.common["Accept"] = "application/json";

app.config.globalProperties.$axios = axios;
app.config.globalProperties.cssVars = cssVars;
library.add({
  faEyeSlash,
  faEye,
  faExclamationTriangle,
  faPlusCircle,
  faBars,
  faUser,
  faInfoCircle,
  faPen,
  faCheckCircle,
  faTimesCircle,
  faArrowLeft,
  faAngleRight,
  faAngleLeft,
  faAngleDown,
  faCircle,
  faTimes,
  faLock,
  faHandHoldingUsd,
  faQuestionCircle,
  faCalendarAlt,
  faCalendarTimes,
  faFilePdf,
  regularFaFilePdf,
  faCopy,
  faExternalLinkAlt,
  faSlidersH,
  faExclamation,
  faEllipsisH,
  faEnvelope,
  faEnvelopeOpen,
  faTrash,
  faFolderOpen,
  faSave,
  faFileWord,
  faFileImage,
  faFilePowerpoint, 
  faFileArchive, 
  faFileVideo, 
  faFileAudio, 
  faFileExcel,
  faFileCsv, 
  faFileCode, 
  faFile
});
app.component('fa-icon', FontAwesomeIcon);
app.use(FloatingVue, {
  themes: {
    tooltip: {
      html: true,
      hideTriggers: (events) => events,
      popperTriggers: ["hover", "focus", "touch"],
    },
  },
});
app.use(InputTrimPlugin);
app.use(FloatingVueEscapeKeyPlugin);
app.directive('maska', vMaska);

app.mount('#login');
